import { useState } from "react";

/** Custom hook to handle pricing of booking */

export const usePrice = () => {
	const [total, setTotal] = useState(null)
	const [specification, setSpecification] = useState([])
	const [priceSettings, setPriceSettings] = useState({})

	const removeSpecification = (filter, removeAll) => {
		const { name, type, owner, price } = filter
		let matchingItems = specification.filter(item =>
			(!name || name === item.name)
			&& (!type || type === item.type)
			&& (!owner || owner === item.owner)
			&& (!price || price === item.price)
		)
		let tempSpecification = specification
		if (removeAll) {
			for (let item of matchingItems) {
				let index = tempSpecification.findIndex(e => e === item)
				if (index >= 0) {
					tempSpecification.splice(index, 1)
				}
			}
		} else {
			let index = tempSpecification.findIndex(e => e === matchingItems[0])
			if (index >= 0) {
				if (tempSpecification[index].quantity > 1) {
					// reduce quantity
					tempSpecification[index].quantity -= 1
				} else {
					tempSpecification.splice(index, 1)
				}
			}
		}
		setSpecification([...tempSpecification])
		updateTotal()
	}

	const addSpecification = (obj) => {

		let { name, type, price, quantity = 1 } = obj
		let tempSpecification = specification
		let index = tempSpecification.findIndex(e => e.name === name && e.type === type && e.price === price)
		if (index >= 0) {
			tempSpecification[index].quantity += quantity
		} else {
			const item = {
				name,
				type,
				quantity,
				price
			}
			tempSpecification.push(item)
		}
		setSpecification([...tempSpecification])
		updateTotal()
	}

	const updateTotal = () => {
		let tempTotal = 0
		for (const item of specification) {
			tempTotal += item.price * item.quantity
		}
		setTotal(tempTotal)
	}

	return {
		removeSpecification,
		addSpecification,
		total,
		specification,
		priceSettings,
		setPriceSettings
	}
}